import { publicRuntimeValue } from "@/lib/public-runtime-config";
/* eslint-disable no-restricted-properties */

import { createEnv } from "@t3-oss/env-nextjs";
import { z } from "zod";

export const Env = createEnv({
  server: {
    STRAPI_URL: z.url(),
    COOKIE_DOMAIN: z.string(),
    ROLLBAR_SERVER_TOKEN: z.string().optional(),
    /* WO-COMMERCE-BIND-001 §14 ruling 1 — the phase-1 booking rail's opt-OUT. Absent (production) means
       snowclub-be booking writes REFUSE, because only the legacy engine emails the operator for approval
       (§10). Set to "enabled" for local/staging snowclub-be development, and by WO-B13 once it has
       re-implemented operator notification there. Optional on purpose: making it required would brick
       every existing environment at boot to express a default that is already fail-closed. */
    SNOWCLUB_BE_BOOKING: z.string().optional(),
  },
  client: {
    NEXT_PUBLIC_APP_URL: z.url(),
    NEXT_PUBLIC_BETTER_STACK_SOURCE_TOKEN: z.string().optional(),
    NEXT_PUBLIC_BETTER_STACK_INGESTING_HOST: z.string().optional(),
    NEXT_PUBLIC_ROLLBAR_CLIENT_TOKEN: z.string().optional(),
    NEXT_PUBLIC_ACCOUNTS_URL: z.url(),
    NEXT_PUBLIC_VENDORS_URL: z.url().optional(),
    NEXT_PUBLIC_CHECKOUT_URL: z.url(),
    NEXT_PUBLIC_API_URL: z.url(),
  },
  shared: {
    NODE_ENV: z.enum(["test", "development", "production"]).optional(),
  },
  // You need to destructure all the keys manually
  runtimeEnv: {
    STRAPI_URL: process.env.STRAPI_URL,
    COOKIE_DOMAIN: process.env.COOKIE_DOMAIN,
    NEXT_PUBLIC_APP_URL: publicRuntimeValue("NEXT_PUBLIC_APP_URL"),
    NEXT_PUBLIC_BETTER_STACK_SOURCE_TOKEN:
      process.env.NEXT_PUBLIC_BETTER_STACK_SOURCE_TOKEN,
    NEXT_PUBLIC_BETTER_STACK_INGESTING_HOST:
      process.env.NEXT_PUBLIC_BETTER_STACK_INGESTING_HOST,
    NEXT_PUBLIC_ACCOUNTS_URL: publicRuntimeValue("NEXT_PUBLIC_ACCOUNTS_URL"),
    NEXT_PUBLIC_VENDORS_URL: publicRuntimeValue("NEXT_PUBLIC_VENDORS_URL"),
    NEXT_PUBLIC_CHECKOUT_URL: process.env.NEXT_PUBLIC_CHECKOUT_URL,
    NEXT_PUBLIC_API_URL: publicRuntimeValue("NEXT_PUBLIC_API_URL"),
    NEXT_PUBLIC_ROLLBAR_CLIENT_TOKEN:
      process.env.NEXT_PUBLIC_ROLLBAR_CLIENT_TOKEN,
    NODE_ENV: process.env.NODE_ENV,
    ROLLBAR_SERVER_TOKEN: process.env.ROLLBAR_SERVER_TOKEN,
    SNOWCLUB_BE_BOOKING: process.env.SNOWCLUB_BE_BOOKING,
  },
  skipValidation:
    !!process.env.CI || process.env.npm_lifecycle_event === "lint",
});
